const { __ } = wp.i18n;

export const attributes = {
	gsBlockId: {
		type: 'string',
	},
	media: {
		type: 'array',
		default: [],
	},
	align: {
		type: 'string',
		default: 'none',
	},
	contentMode: {
		type: 'string',
		default: 'change',
	},
	bgImageId: {
		type: 'number',
	},
	animation: {
		type: 'string',
		default: 'slide',
	},
	fadeMode: {
		type: 'boolean',
		default: true,
	},
	slidesToShow: {
		type: 'number',
		default: 1,
	},
	slidesToScroll: {
		type: 'number',
		default: 1,
	},
	sliderHeight: {
		type: 'string',
		default: '50vh',
	},
	isFullScreen: {
		type: 'boolean',
		default: false,
	},
	pauseOnFocus: {
		type: 'boolean',
		default: true,
	},
	pauseOnHover: {
		type: 'boolean',
		default: true,
	},
	pauseOnDotsHover: {
		type: 'boolean',
		default: true,
	},
	enableSpacing: {
		type: 'boolean',
		default: true,
	},
	paddingX: {
		type: 'string',
		default: '40px',
	},
	paddingY: {
		type: 'string',
		default: '40px',
	},
	spacingX: {
		type: 'number',
		default: 40,
	},
	spacingY: {
		type: 'number',
		default: 40,
	},
	spacingXMobile: {
		type: 'number',
		default: 40,
	},
	spacingYMobile: {
		type: 'number',
		default: 40,
	},
	spacingXTablet: {
		type: 'number',
		default: 40,
	},
	spacingYTablet: {
		type: 'number',
		default: 40,
	},
	spacingXDesktop: {
		type: 'number',
		default: 40,
	},
	spacingYDesktop: {
		type: 'number',
		default: 40,
	},
	spacingYUnit: {
		type: 'string',
		default: 'px',
	},
	spacingXUnit: {
		type: 'string',
		default: 'px',
	},
	autoplay: {
		type: 'boolean',
		default: true,
	},
	duration: {
		type: 'number',
		default: 3,
	},
	fadeSpeed: {
		type: 'number',
		default: 0.6,
	},
	arrows: {
		type: 'boolean',
		default: true,
	},
	arrowSize: {
		type: 'number',
		default: 30,
	},
	arrowColor: {
		type: 'string',
		default: '#ffffff',
	},
	arrowStyle: {
		type: 'string',
		default: 'arrow-style-1',
	},
	arrowBgColor: {
		type: 'string',
		default: 'transparent',
	},
	arrowHoverColor: {
		type: 'string',
		default: '#eeeeee',
	},
	arrowBgHoverColor: {
		type: 'string',
		default: 'transparent',
	},
	arrowXOffset: {
		type: 'number',
		default: 10,
	},
	arrowYOffset: {
		type: 'number',
		default: 0,
	},
	arrowPosition: {
		type: 'string',
		default: 'arrow-position-sides',
	},
	arrowMixBlendMode: {
		type: 'string',
		default: 'none',
	},
	dots: {
		type: 'boolean',
		default: true,
	},
	dotSize: {
		type: 'number',
		default: 25,
	},
	dotColor: {
		type: 'string',
		default: '#ffffff',
	},
	dotStyle: {
		type: 'string',
		default: 'dot-style-1',
	},
	dotPosition: {
		type: 'string',
		default: 'dot-position-bottom',
	},
	dotYOffset: {
		type: 'number',
		default: 10,
	},
	hasParallax: {
		type: 'boolean',
		default: false,
	},
	parallaxDirection: {
		type: 'string',
		default: 'down',
	},
	parallaxAmount: {
		type: 'number',
		default: 1.3,
	},
	overlayColor: {
		type: 'string',
	},
	dimRatio: {
		type: 'number',
		default: 0.5,
	},
	rgbaBackground: {
		type: 'string',
		default: '',
	},
	textColor: {
		type: 'string',
	},
	mixBlendMode: {
		type: 'string',
		default: 'none',
	},
	contentOpacity: {
		type: 'number',
		default: 1,
	},
	verticalAlign: {
		type: 'string',
		default: 'center',
	},
	loop: {
		type: 'boolean',
		default: true,
	},
	visibleOnDesktop: {
		type: 'boolean',
		default: true,
	},
	visibleOnTablet: {
		type: 'boolean',
		default: true,
	},
	visibleOnMobile: {
		type: 'boolean',
		default: true,
	},
	adaptiveHeight: {
		type: 'boolean',
		default: false,
	},
	contentPosition: {
		type: 'string',
	},
	autoCaption: {
		type: 'string',
		default: 'none',
	},
	arrowXSpacing: {
		type: 'number',
		default: 0,
	},
	zoom: {
		type: 'boolean',
		default: false,
	},
	spaceBetween: {
		type: 'number',
		default: 0,
	},
	centeredSlides: {
		type: 'boolean',
		default: true,
	},
	dotType: {
		type: 'string',
		default: 'bullets',
	},
	isVertical: {
		type: 'boolean',
		default: false,
	},
	hasLg: {
		type: 'boolean',
		default: false,
	},
	lightgalleryTranstion: {
		type: 'string',
		default: 'lg-slide',
	},
	lgBgColor: {
		type: 'string',
		default: '#fff',
	},
	lgFontColor: {
		type: 'string',
		default: '#fff',
	},
	lgTitle: {
		type: 'string',
		default: 'none',
	},
	lgCaption: {
		type: 'string',
		default: 'none',
	},
	hasLgCounter: {
		type: 'boolean',
		default: true,
	},
};

export const MAX_SLIDES = 20;

export const PARALLAX_DIRECTIONS = [
	{ value: 'down', label: __( '↓ top to bottom', 'gutenslider' ) },
	{ value: 'up', label: __( '↑ bottom to top', 'gutenslider' ) },
	{ value: 'right', label: __( '→ left to right', 'gutenslider' ) },
	{ value: 'left', label: __( '← right to left', 'gutenslider' ) },
	{ value: 'down left', label: __( '↙ top right to bottom left', 'gutenslider' ) },
	{ value: 'down right', label: __( '↘ top left to bottom right', 'gutenslider' ) },
	{ value: 'up left', label: __( '↖ bottom right to top left', 'gutenslider' ) },
	{ value: 'up right', label: __( '↗ bottom left to top right', 'gutenslider' ) },
];

export const ARROW_POSITIONS = [
	{ value: 'arrow-position-sides', label: __( 'Left + Right', 'gutenslider' ) },
	{ value: 'arrow-position-top-left', label: __( 'Top Left', 'gutenslider' ) },
	{ value: 'arrow-position-top-right', label: __( 'Top Right', 'gutenslider' ) },
	{ value: 'arrow-position-bottom-left', label: __( 'Bottom Left', 'gutenslider' ) },
	{ value: 'arrow-position-bottom-right', label: __( 'Bottom Right', 'gutenslider' ) },
	{ value: 'arrow-position-top-bottom', label: __( 'Top + Bottom', 'gutenslider' ) },
	{ value: 'arrow-follow-mouse', label: __( 'Arrows Follow Mouse', 'gutenslider' ) },
];

export const DOT_POSITIONS = [
	{ value: 'dot-position-top', label: __( 'Top', 'gutenslider' ), showIn: [ 'dynamic', 'bullets', 'fraction', 'progressbar' ] },
	{ value: 'dot-position-bottom', label: __( 'Bottom', 'gutenslider' ), showIn: [ 'dynamic', 'bullets', 'fraction', 'progressbar' ] },
	{ value: 'dot-position-left', label: __( 'Left', 'gutenslider' ), showIn: [ 'bullets', 'fraction', 'progressbar'] },
	{ value: 'dot-position-right', label: __( 'Right', 'gutenslider' ), showIn: [ 'bullets', 'fraction', 'progressbar' ] },
	{ value: 'dot-position-top-left', label: __( 'Top Left', 'gutenslider' ), showIn: [ 'fraction' ] },
	{ value: 'dot-position-top-right', label: __( 'Top Right', 'gutenslider' ), showIn: [ 'fraction' ] },
	{ value: 'dot-position-bottom-left', label: __( 'Bottom Left', 'gutenslider' ), showIn: [ 'fraction' ] },
	{ value: 'dot-position-bottom-right', label: __( 'Bottom Right', 'gutenslider' ), showIn: [ 'fraction' ] },
];

export const DOT_STYLES = [
	{ value: 'dot-style-1', label: __( 'Style 1', 'gutenslider' ) },
	{ value: 'dot-style-2', label: __( 'Style 2', 'gutenslider' ) },
	{ value: 'dot-style-3', label: __( 'Style 3', 'gutenslider' ) },
	{ value: 'dot-style-4', label: __( 'Style 4', 'gutenslider' ) },
];

export const LIGHTGALLERY_TRANSITIONS = [
	{ value: 'lg-slide', label: __( 'Slide', 'eedee-gutenslider' ) },
	{ value: 'lg-fade', label: __( 'Fade', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-in', label: __( 'Zoom In', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-in-big', label: __( 'Zoom In Big', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-out', label: __( 'Zoom Out', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-out-big', label: __( 'Zoom Out Big', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-out-in', label: __( 'Zoom Out In', 'eedee-gutenslider' ) },
	{ value: 'lg-zoom-in-out', label: __( 'Zoom In Out', 'eedee-gutenslider' ) },
	{ value: 'lg-soft-zoom', label: __( 'Soft Zoom', 'eedee-gutenslider' ) },
	{ value: 'lg-scale-up', label: __( 'Scale Up', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-circular', label: __( 'Slide Circular', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-circular-vertical', label: __( 'Slide Circular Vertical', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-vertical', label: __( 'Slide Vertical', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-vertical-growth', label: __( 'Slide Vertical Growth', 'eedee-gutenslider' ) },
	{ value: 'lg-lollipop', label: __( 'Lollipop', 'eedee-gutenslider' ) },
	{ value: 'lg-lollipop-rev', label: __( 'Lollipop Reverse', 'eedee-gutenslider' ) },
	{ value: 'lg-rotate', label: __( 'Rotate', 'eedee-gutenslider' ) },
	{ value: 'lg-rotate-rev', label: __( 'Rotate Reverse', 'eedee-gutenslider' ) },
	{ value: 'lg-tube', label: __( 'Tube', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-only', label: __( 'Slide Skew Only', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-only-rev', label: __( 'Slide Skew Only Rev', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-only-y', label: __( 'Slide Skew Only Y', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-only-y-rev', label: __( 'Slide Skew Only Y Rev', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew', label: __( 'Slide Skew', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-rev', label: __( 'Slide Skew Rev', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-cross', label: __( 'Slide Skew Cross', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-cross-rev', label: __( 'Slide Skew Cross Rev', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-ver', label: __( 'Slide Skew Vertical', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-ver-rev', label: __( 'Slide Skew Vertical Rev', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-ver-cross', label: __( 'Slide Skew Vertical Cross', 'eedee-gutenslider' ) },
	{ value: 'lg-slide-skew-ver-cross-rev', label: __( 'Slide Skew Vertical Cross Rev', 'eedee-gutenslider' ) },
];

export const LIGHTGALLERY_TITLE = [
	{ value: 'none', label: __( 'None', 'eedee-gutenslider' ) },
	{ value: 'title', label: __( 'Media Title', 'eedee-gutenslider' ) },
	{ value: 'alt', label: __( 'Media Alt', 'eedee-gutenslider' ) },
];

export const LIGHTGALLERY_DESCRIPTION = [
	{ value: 'none', label: __( 'None', 'eedee-gutenslider' ) },
	{ value: 'caption', label: __( 'Media Caption', 'eedee-gutenslider' ) },
	{ value: 'description', label: __( 'Media Description', 'eedee-gutenslider' ) },
	{ value: 'alt', label: __( 'Media Alt', 'eedee-gutenslider' ) },
];
